import meditationResourceChange from './actions/meditationResourceChange';
import meditationResourceCreate from './actions/meditationResourceCreate';
import meditationResourceDetail from './actions/meditationResourceDetail';
import meditationResourcesList from './actions/meditationResourcesList';
import getMeditationResources from './getters/getMeditationResources';
import meditationResourcesUpload from './mutations/meditationResourcesUpload';

const actions = {
    meditationResourceChange,
    meditationResourceCreate,
    meditationResourceDetail,
    meditationResourcesList
};

const mutations = {
    meditationResourcesUpload
};

const getters = {
    getMeditationResources
};

export default { actions, mutations, getters };
